// import { API } from "../../../config/API";

// const homeCache = async () => {};

// const refreshNewsCache = async (id: any) => {
//   let url = API.CACHE_SERVER_4 + API.REFRESH_CACHE + id;
//   let res = await fetch(url, {
//     method: "GET",
//     referrerPolicy: "unsafe-url",
//   });
//   let data = await res.json();
//   if (data?.revalidated) {
//     console.log("Cache revalidated for id:", id);
//   } else {
//     console.log("Couldn't refresh cache for id:", id);
//   }
// };

// export { homeCache, refreshNewsCache };

import { API } from "../../../config/API";
import { notification } from "antd";

const homeCache = async () => {};

const refreshNewsCache = async (id: any) => {
  try {
    if (!id) {
      throw new Error("News ID is required");
    }

    let url = API.CACHE_SERVER_4 + API.REFRESH_CACHE + id;

    let res = await fetch(url, {
      method: "GET",
      referrerPolicy: "unsafe-url",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    let data = await res.json();

    if (data?.revalidated) {
      notification.success({
        message: "Cache Refreshed",
        description: "Content has been updated successfully",
      });
      console.log("Cache revalidated for id:", id);
    } else {
      throw new Error("Cache revalidation failed");
    }

    return data;
  } catch (error: any) {
    console.error("Cache refresh failed:", error);
    notification.error({
      message: "Cache Refresh Failed",
      description: error.message || "Please try again later",
    });
    return { revalidated: false, error: error.message };
  }
};

export { homeCache, refreshNewsCache };
